<template>
  <div class="dayplanner-suggestions" v-if="suggestion_item_lists_grouped_and_filtered">

    <img src="/assets/mock/dayplanner_suggestions@2x.png" style="width: 375px; left: -0.5rem; position: relative;" />

    <div style="margin-top: 30em"></div>

    <el-collapse v-model="collapse_list" class="mt-4">
      <el-collapse-item
        v-for="suggestion_item_list in suggestion_item_lists_grouped_and_filtered"
        :key="suggestion_item_list.$key"
        :title="suggestion_item_list.title"
        :name="suggestion_item_list.$id"
        :type="suggestion_item_list.type">
        <suggestion-drag-list :item-list="suggestion_item_list.items" :clone="cloneItem">
          <component
            class="action-draggable"
            v-for="suggestion_item in suggestion_item_list.items"
            v-bind:is="suggestion_item.componentSuggestion"
            :key="suggestion_item.$key"
            :item-id="suggestion_item.$id"
            :type="suggestion_item.type"
            :config="suggestion_item.config"
            :name="suggestion_item.title"
            :date-timestamp="dateTimestamp"
            @add="onAddSuggestionItem(suggestion_item_list.$id, suggestion_item, $event)"
          />
        </suggestion-drag-list>
      </el-collapse-item>
    </el-collapse>

    <!-- <pre class="mini-pre" v-if="SHOW_DEBUG">{{suggestion_item_lists_grouped_and_filtered}}</pre> -->
  </div>
</template>

<script>
import { mapReady } from "@/api/misc";
import Draggable from "vuedraggable";
import ItemTasklist from "./Suggestions/ItemTasklist";
import ItemSequence from "./Suggestions/ItemSequence";
import ItemTime from "./Suggestions/ItemTime";
import ItemAmount from "./Suggestions/ItemAmount";
import ItemHabit from "./Suggestions/ItemHabit";
import ItemFixedTimeEvent from "./Suggestions/ItemFixedTimeEvent";
import ItemTimeBlock from "./Suggestions/ItemTimeBlock";
import ItemQuickSession from "./Suggestions/ItemQuickSession";
import ItemRecommendation from "./Suggestions/ItemRecommendation";
import SuggestionDragList from "./SuggestionDragList";

import { make_block, time } from "../API/util";

import clonedeep from "lodash.clonedeep";
import moment from "@/moment-gp.js";

export default {
  props: {
    dateTimestamp: {
      type: Number
    }
  },
  data: () => ({
    collapse_list: [3]
  }),
  computed: {
    ...mapReady("commitments"),

    suggestion_item_lists_grouped_and_filtered() {
      return [
        {
          $id: 3,
          title: "Special",
          items: this.special_items,
          type: "SPECIAL"
        },
        {
          $id: 4,
          title: "Recent Items",
          items: this.recent_items,
          type: "RECENT"
        },
        {
          $id: 5,
          title: "Developer",
          items: this.developer_items,
          type: "DEVELOPER"
        },
      ];
    },

    developer_items() {
      return [
       {
          $key: 1,
          $id: 1,
          $groupId: 5,
          ...make_block("START_DAY", time("6:00"), null, "Wake Up", {}),
          componentSuggestion: "item-fixed-time-event"
        },
        {
          $key: 2,
          $id: 2,
          $groupId: 5,
          ...make_block("END_DAY", time("22:00"), null, "Go to bed", {}),
          componentSuggestion: "item-fixed-time-event"
        }
      ]
    },

    special_items() {
      return [
        /*{
          $key: 1,
          $id: 1,
          $groupId: 3,
          ...make_block("INLINE_TASK", null, null, "Task", {}),
          componentSuggestion: "item-quick-session"
        },
        {
          $key: 2,
          $id: 2,
          $groupId: 3,
          ...make_block("PAUSE", null, null, "Pause", {}),
          componentSuggestion: "item-quick-session"
        },
        {
          $key: 3,
          $id: 3,
          $groupId: 3,
          ...make_block("PAUSE", null, null, "Fahrzeit", {}),
          componentSuggestion: "item-quick-session"
        },
        {
          $key: 4,
          $id: 4,
          $groupId: 3,
          ...make_block("FIXED_TIME", null, null, "Fixed Time / Meeting", {}),
          componentSuggestion: "item-fixed-time-event"
        },*/
        {
          $key: 5,
          $id: 5,
          $groupId: 3,
          ...make_block("ADHOC_SESSION", null, null, "Add new Checklist", {}),
          componentSuggestion: "item-quick-session"
        }
      ];
    },

    recent_items() {
      return [
        {
          $key: 1,
          $id: 1,
          $groupId: 3,
          title: "Frequently Used Task 1",
          componentSuggestion: "item-fixed-time-event",
          component: "flow-fixed-time-event",
          type: "fixed-time-event"
        },
        {
          $key: 2,
          $id: 2,
          $groupId: 3,
          title: "Frequently Used Task 2",
          componentSuggestion: "item-fixed-time-event",
          component: "flow-fixed-time-event",
          type: "fixed-time-event"
        }
      ];
    }
  },
  methods: {
    cloneItem(item) {

      let item_clone = clonedeep(item);
      item_clone.id = item_clone.$id;
      item_clone.groupId = item_clone.$groupId;
      delete item_clone.$key; /* remove key */
      delete item_clone.$id; /* remove key */
      delete item_clone.$groupId; /* remove key */
      item_clone.description = null; /* Remove description, so user can set it */
      item_clone.just_dropped = true;

      console.log("[DND] cloneItem 3", item_clone)
      return item_clone;
    },

    onAddSuggestionItem(groupId, item, $event = {}) {
      let item_clone = this.cloneItem(item);
      console.log('onAddItem',item_clone)
      if ( $event && $event.suggestedFrom ) {
        item_clone.devSuggestedFrom = moment.unix( $event.suggestedFrom ).format('LLL')
      }

      Object.assign(item_clone, $event);

      console.log("onAddSuggestionItem", item_clone, "$event ", $event);
      this.$emit("add", item_clone);
    }
  },
  components: {
    Draggable,
    ItemTasklist,
    ItemSequence,
    ItemTime,
    ItemAmount,
    ItemHabit,
    ItemTimeBlock,
    ItemFixedTimeEvent,
    ItemQuickSession,
    ItemRecommendation,
    SuggestionDragList,
  }
};
</script>

<style>
</style>
